// src/components/form/form.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  query FormQuery($context: ContextInput!, $propertyId: String!, $roomInput: [RoomInput!], $dateRange: PropertyDateRangeInput) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      searchForm(roomInput: $roomInput, dateRange: $dateRange) @client {\n        id\n        method\n        action\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  query DateFieldRatesQuery($context: ContextInput!, $propertyId: String!, $roomInput: [RoomInput!]!, $dateRange: PropertyDateRangeInput!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      propertyCalendar(dateRange: $dateRange, roomInput: $roomInput) {\n        propertyCalendarRates {\n          date {\n            isoFormat\n          }\n          displayPrice\n          accessibilityLabel\n          theme\n        }\n        disclaimer {\n          value\n        }\n      }\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment DateOrderValidationFragment on DateOrderValidation {\n    events\n    error\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EndDateRequiredValidationFragment on EndDateRequiredValidation {\n    events\n    error\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment MaxDateRangeValidationFragment on MaxDateRangeValidation {\n    events\n    error\n    maxDateRange\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment StartDateRequiredValidationFragment on StartDateRequiredValidation {\n    events\n    error\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment DateFieldFragment on LodgingFormDateField {\n    startId\n    startName\n    startLabel\n    startPlaceholder\n    startInvalid\n\n    endId\n    endName\n    endLabel\n    endPlaceholder\n    endInvalid\n\n    buttonText\n    daysBookableInAdvance\n    midnightBookingOffset\n\n    validations {\n      ...DateOrderValidationFragment\n      ...MaxDateRangeValidationFragment\n      ...StartDateRequiredValidationFragment\n      ...EndDateRequiredValidationFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment SubmitButtonFragment on LodgingFormSubmitButton {\n    label\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  query FormFieldQuery($context: ContextInput!, $propertyId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      searchForm @client {\n        fields {\n          ...DateFieldFragment\n          ...SubmitButtonFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment TravelersSummaryFragment on TravelersSummary {\n    roomsAndGuests\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment ChildrenAgesFragment on ChildrenAges {\n    childAgeUpdatedLiveAnnounce\n    selectChildAgeLabel\n    youngestChildAgeText\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment TravelersStepInputFragment on StepInput {\n    title\n    increaseText\n    decreaseText\n    caption\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment RoomFragment on RoomField {\n    roomTitleAriaLabel\n    roomTitle\n    removeRoomButtonLabel\n    removeRoomButtonAriaLabel\n    roomRemovedLiveAnnounce\n\n    adultsStepInput {\n      ...TravelersStepInputFragment\n    }\n    childrenStepInput {\n      ...TravelersStepInputFragment\n    }\n\n    childrenAges {\n      ...ChildrenAgesFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment RoomPickerFragment on LodgingFormTravelers {\n    roomPicker {\n      accessibility\n      toolBarIconLabel\n      toolBarTitle\n      addRoomText\n      doneLabel\n      roomAddedLiveAnnounce\n      room {\n        ...RoomFragment\n      }\n    }\n    travelersSummary {\n      ...TravelersSummaryFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment TravelersFieldFragment on LodgingFormTravelers {\n    label\n    travelersSummary {\n      ...TravelersSummaryFragment\n    }\n    ...RoomPickerFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
import React4 from "react";
import { gql } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/__generated__/types.ts
var LodgingFormEvent = /* @__PURE__ */function (LodgingFormEvent2) {
  LodgingFormEvent2["ON_CHANGE"] = "ON_CHANGE";
  LodgingFormEvent2["ON_LOAD"] = "ON_LOAD";
  LodgingFormEvent2["ON_SUBMIT"] = "ON_SUBMIT";
  return LodgingFormEvent2;
}(LodgingFormEvent || {});
// src/components/form/form-action-context.tsx
import React from "react";
var FormActionContext = React.createContext( /* istanbul ignore next -- @preserve */function () {
  return void 0;
});
var useFormAction = function () {
  return React.useContext(FormActionContext);
};
var FormActionProvider = FormActionContext.Provider;
// src/components/form/form-input-context.tsx
import React2 from "react";
import { useBexApi } from "@shared-ui/bex-api-context";
var FormInputContext = React2.createContext(null);
var useFormInputs = function () {
  return React2.useContext(FormInputContext);
};
var FormInputsProvider = function (param) {
  var children = param.children,
    value = param.value;
  var context = useBexApi().context;
  return /* @__PURE__ */React2.createElement(FormInputContext.Provider, {
    value: _object_spread_props(_object_spread({}, value), {
      context: context
    })
  }, children);
};
// src/components/form/form-validation-context.tsx
import React3 from "react";
var FormValidationContext = React3.createContext({
  addExecutor: function (executor) {
    return [executor];
  }
});
var useFormValidation = function () {
  return React3.useContext(FormValidationContext);
};
var FormValidationProvider = FormValidationContext.Provider;
// src/components/form/form.tsx
var __Query = gql(_templateObject());
var LodgingForm = function (props) {
  var inputs = props.inputs,
    data = props.data,
    children = props.children,
    formRef = props.formRef;
  var context = useBexApi2().context;
  var _React4_useState = _sliced_to_array(React4.useState([]), 2),
    validationExecutors = _React4_useState[0],
    setValidationExecutors = _React4_useState[1];
  var addExecutor = React4.useCallback(function (executor) {
    setValidationExecutors(_to_consumable_array(validationExecutors).concat([executor]));
  }, [validationExecutors, setValidationExecutors]);
  var variable = _object_spread_props(_object_spread({}, inputs || {}), {
    context: context
  });
  var dispatch = useFormAction();
  var onSubmit = React4.useCallback(function (event) {
    var formData = new FormData(event.target);
    if (validationExecutors.some(function (executor) {
      return !executor(formData, "ON_SUBMIT" /* ON_SUBMIT */);
    })) {
      event.preventDefault();
      return;
    }
    dispatch({
      type: "submit",
      event: event,
      data: formData
    });
  }, [dispatch, validationExecutors]);
  if (!data) {
    return null;
  }
  var method = data.method,
    action = data.action,
    id = data.id;
  return /* @__PURE__ */React4.createElement("form", {
    method: method,
    action: action,
    id: id,
    onSubmit: onSubmit,
    "data-stid": "lodging-form",
    ref: formRef
  }, /* @__PURE__ */React4.createElement(FormInputsProvider, {
    value: variable
  }, /* @__PURE__ */React4.createElement(FormValidationProvider, {
    value: {
      addExecutor: addExecutor
    }
  }, children)));
};
LodgingForm.displayName = "sharedui-LodgingForm";
// src/components/form/fields/date-field/date-field.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { DayName, EGDSDatePicker } from "@egds/react-core/date-picker";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
import { useLogger } from "@shared-ui/logger-context";
// src/components/form/contexts/referrer.ts
import { createContext, useContext } from "react";
var defaultReferrerContext = {
  referrer: {
    pagePrefix: ""
  }
};
var ReferrerContext = createContext(defaultReferrerContext);
function useReferrerContext() {
  return useContext(ReferrerContext);
}
// src/components/form/fields/date-field/actions/fetch-rates-action.ts
import React5 from "react";
import { gql as gql2, useLazyQuery } from "@apollo/client";
var __DateFieldRatesQuery = gql2(_templateObject1());
var NOOP = function () {
  return {};
};
var getDateSpan = function (date, span) {
  var today = /* @__PURE__ */new Date();
  var nDaysBeforeDate = new Date(date);
  nDaysBeforeDate.setDate(date.getDate() - span / 2);
  var startDate = nDaysBeforeDate;
  if (nDaysBeforeDate < today) {
    startDate = today;
  }
  var endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + span);
  return {
    startDate: startDate,
    endDate: endDate
  };
};
var getClassName = function (theme) {
  switch (theme) {
    case "AGGRESSIVE" /* AGGRESSIVE */:
      return "negative" /* AGGRESSIVE */;
    case "HIGHLIGHT" /* HIGHLIGHT */:
      return "positive" /* HIGHLIGHT */;
    default:
      return "";
  }
};
var adaptRates = function (rates) {
  if (!rates) {
    return void 0;
  }
  return rates.reduce(function (content, rate) {
    var newContent = _object_spread({}, content);
    newContent[rate.date.isoFormat] = {
      text: rate.displayPrice,
      className: getClassName(rate.theme),
      ariaLabel: rate.accessibilityLabel
    };
    return newContent;
  }, {});
};
var mergeRates = function (prev, next) {
  var dates = /* @__PURE__ */new Set();
  var rates = next.map(function (rate) {
    dates.add(rate.date.isoFormat);
    return rate;
  });
  prev.filter(function (rate) {
    return !dates.has(rate.date.isoFormat);
  }).forEach(function (rate) {
    rates.push(rate);
  });
  return rates;
};
var updateRatesQuery = function (prev, param) {
  var fetchMoreResult = param.fetchMoreResult;
  if (!fetchMoreResult) {
    return prev;
  }
  if (!prev || typeof prev === "object" && Object.keys(prev).length === 0) {
    return fetchMoreResult;
  }
  return {
    propertyInfo: _object_spread_props(_object_spread({}, prev.propertyInfo), {
      propertyCalendar: _object_spread_props(_object_spread({}, prev.propertyInfo.propertyCalendar), {
        disclaimer: fetchMoreResult.propertyInfo.propertyCalendar.disclaimer,
        propertyCalendarRates: mergeRates(prev.propertyInfo.propertyCalendar.propertyCalendarRates, fetchMoreResult.propertyInfo.propertyCalendar.propertyCalendarRates)
      })
    })
  };
};
var fetchMoreRates = function (fetchMore, variables) {
  return function (date) {
    var _getDateSpan = getDateSpan(date, 90),
      startDate = _getDateSpan.startDate,
      endDate = _getDateSpan.endDate;
    var dateRange = {
      checkInDate: {
        day: startDate.getDate(),
        month: startDate.getMonth() + 1,
        year: startDate.getFullYear()
      },
      checkOutDate: {
        day: endDate.getDate(),
        month: endDate.getMonth() + 1,
        year: endDate.getFullYear()
      }
    };
    var newVariables = _object_spread_props(_object_spread({}, variables || {}), {
      dateRange: dateRange
    });
    fetchMore === null || fetchMore === void 0 ? void 0 : fetchMore({
      variables: newVariables,
      updateQuery: updateRatesQuery
    });
  };
};
var useFetchRatesAction = function (hasDates) {
  var inputs = useFormInputs();
  var inputWithDefaultRooms = _object_spread_props(_object_spread({}, inputs), {
    roomInput: [{
      adults: 2
    }]
  });
  var _useLazyQuery = _sliced_to_array(useLazyQuery(__DateFieldRatesQuery, {
      ssr: false,
      variables: inputWithDefaultRooms || {}
    }), 2),
    fetchRates = _useLazyQuery[0],
    _useLazyQuery_ = _useLazyQuery[1],
    data = _useLazyQuery_.data,
    fetchMore = _useLazyQuery_.fetchMore;
  React5.useEffect(function () {
    if (hasDates) {
      fetchRates();
    }
  }, [fetchRates, hasDates]);
  if (!hasDates) {
    return [{}, "", NOOP];
  }
  var rates = adaptRates(data === null || data === void 0 ? void 0 : data.propertyInfo.propertyCalendar.propertyCalendarRates);
  var disclaimer = (data === null || data === void 0 ? void 0 : data.propertyInfo.propertyCalendar.disclaimer.value) || "";
  return [rates, disclaimer, fetchMoreRates(fetchMore, inputWithDefaultRooms)];
};
// src/components/form/fields/date-field/analytics.ts
var setupAnalytics = function (id, description, track) {
  return {
    id: id,
    description: description,
    callback: function () {
      return track(id, description, true);
    }
  };
};
var getAnalytics = function (pagePrefix, track, hasDates) {
  return {
    startAnalytics: setupAnalytics("".concat(pagePrefix, ":ChangeDatesCheckIn"), "Open Date Picker", track),
    endAnalytics: setupAnalytics("".concat(pagePrefix, ":ChangeDatesCheckOut"), "Open Date Picker", track),
    datePickerAnalytics: {
      closeAnalytics: setupAnalytics("".concat(pagePrefix, ":ChangeDatesClose"), "Close Date Picker", track),
      doneAnalytics: hasDates ? setupAnalytics("".concat(pagePrefix, ":ChangeDatesDone"), "Apply Date Picker", track) : setupAnalytics("".concat(pagePrefix, ":Datepicker-Done-Button-Pressed"), "Search Date Picker", track),
      nextPageAnalytics: setupAnalytics("".concat(pagePrefix, ":NextMonthClick"), "Next Month Click", track),
      previousPageAnalytics: setupAnalytics("".concat(pagePrefix, ":PreviousMonthClick"), "Previous Month Click", track)
    }
  };
};
// src/components/form/fields/date-field/uitk-wrappers.tsx
import React6 from "react";
import { EGDSDatePickerTriggeredSelector } from "@egds/react-core/date-picker";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { useDialog } from "@shared-ui/dialog-context";
var useDialogWrappers = function () {
  var _useDialog = _sliced_to_array(useDialog("datepicker-start"), 3),
    startIsOpen = _useDialog[0],
    startDialogActions = _useDialog[1],
    StartDialogComponent = _useDialog[2];
  var _useDialog1 = _sliced_to_array(useDialog("datepicker-end"), 3),
    endIsOpen = _useDialog1[0],
    endDialogActions = _useDialog1[1],
    EndDialogComponent = _useDialog1[2];
  var dialogWrapper = function (children, dateType) {
    if (dateType === EGDSDatePickerTriggeredSelector.END) {
      return /* @__PURE__ */React6.createElement(EGDSSheetTransition, {
        isVisible: endIsOpen
      }, /* @__PURE__ */React6.createElement(EndDialogComponent, null, /* @__PURE__ */React6.createElement(React6.Fragment, null, children)));
    }
    return /* @__PURE__ */React6.createElement(EGDSSheetTransition, {
      isVisible: startIsOpen
    }, /* @__PURE__ */React6.createElement(StartDialogComponent, null, /* @__PURE__ */React6.createElement(React6.Fragment, null, children)));
  };
  var openDialog = function (dateType) {
    if (dateType === EGDSDatePickerTriggeredSelector.END) {
      endDialogActions.openDialog();
    } else {
      startDialogActions.openDialog();
    }
  };
  var dismissDialog = function () {
    if (endIsOpen) {
      endDialogActions.closeDialog();
    } else {
      startDialogActions.closeDialog();
    }
  };
  return [dialogWrapper, openDialog, dismissDialog];
};
var routerLinkWrapper = function (children) {
  return children;
};
// src/components/form/fields/date-field/validations/date-order-validation.ts
import { gql as gql3 } from "@apollo/client";
var __DateOrderValidationFragment = gql3(_templateObject2());
function executeDateOrderValidation(action, values) {
  var startDate = values.startDate,
    endDate = values.endDate;
  if (!startDate || !endDate || !isValidDate(startDate) || !isValidDate(endDate)) {
    return [true, "start"];
  }
  return [startDate < endDate, "end"];
}
// src/components/form/fields/date-field/validations/end-date-required-validation.ts
import { gql as gql4 } from "@apollo/client";
var __EndDateRequiredValidationFragment = gql4(_templateObject3());
function executeEndDateRequiredValidation(action, values) {
  var endDate = values.endDate;
  if (!endDate || !isValidDate(endDate)) {
    return [false, "end"];
  }
  return [true, "start"];
}
// src/components/form/fields/date-field/validations/max-date-range-validation.ts
import { gql as gql5 } from "@apollo/client";
var __MaxDateRangeValidationFragment = gql5(_templateObject4());
function executeMaxDateRangeValidation(action, values) {
  var startDate = values.startDate,
    endDate = values.endDate;
  if (!startDate || !endDate || !isValidDate(startDate) || !isValidDate(endDate)) {
    return [true, "end"];
  }
  var maxEndDate = new Date(startDate);
  maxEndDate.setDate(maxEndDate.getDate() + action.maxDateRange);
  return [endDate <= maxEndDate, "end"];
}
// src/components/form/fields/date-field/validations/start-date-required-validation.ts
import { gql as gql6 } from "@apollo/client";
var __StartDateRequiredValidationFragment = gql6(_templateObject5());
function executeStartDateRequiredValidation(action, values) {
  var startDate = values.startDate;
  if (!startDate || !isValidDate(startDate)) {
    return [false, "start"];
  }
  return [true, "start"];
}
// src/components/form/fields/date-field/validations/execute-validations.ts
function executeValidations(event, validations, value) {
  if (!validations || !validations.length) {
    return [];
  }
  return validations.reduce(function (errors, validation) {
    var success = true,
      dateType = null;
    var parsedErrors = _to_consumable_array(errors);
    if (!validation.events.find(function (e) {
      return e === event;
    })) {
      return parsedErrors;
    }
    switch (validation.__typename) {
      case "DateOrderValidation":
        var ref;
        ref = _sliced_to_array(executeDateOrderValidation(validation, value), 2), success = ref[0], dateType = ref[1], ref;
        break;
      case "MaxDateRangeValidation":
        var ref1;
        ref1 = _sliced_to_array(executeMaxDateRangeValidation(validation, value), 2), success = ref1[0], dateType = ref1[1], ref1;
        break;
      case "StartDateRequiredValidation":
        var ref2;
        ref2 = _sliced_to_array(executeStartDateRequiredValidation(validation, value), 2), success = ref2[0], dateType = ref2[1], ref2;
        break;
      case "EndDateRequiredValidation":
        var ref3;
        ref3 = _sliced_to_array(executeEndDateRequiredValidation(validation, value), 2), success = ref3[0], dateType = ref3[1], ref3;
        break;
      default:
        break;
    }
    if (!success) {
      parsedErrors.push({
        message: validation.error,
        dateType: dateType
      });
      return _to_consumable_array(parsedErrors);
    }
    return parsedErrors;
  }, []);
}
// src/components/form/fields/date-field/date-field.tsx
var TODAY = /* @__PURE__ */new Date();
var fragment = gql7(_templateObject6(), __DateOrderValidationFragment, __MaxDateRangeValidationFragment, __StartDateRequiredValidationFragment, __EndDateRequiredValidationFragment);
var isValidDate = function (date) {
  return Boolean(date && date.toDateString() !== "Invalid Date");
};
var parseDateInput = function (dateInput) {
  if (!dateInput) {
    return void 0;
  }
  var year = dateInput.year,
    month = dateInput.month,
    day = dateInput.day;
  var date = new Date(year, month - 1, day);
  return date;
};
var parseDate = function (date) {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
};
var focus = function (ref) {
  var _ref_current;
  if (typeof (ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus) === "function") {
    ref.current.focus();
  }
};
var DateField = function (param) {
  var autoOpenCalendar = param.autoOpenCalendar,
    _param_closeOnSubmit = param.closeOnSubmit,
    closeOnSubmit = _param_closeOnSubmit === void 0 ? true : _param_closeOnSubmit,
    data = param.data,
    endDateRef = param.endDateRef,
    fieldName = param.fieldName,
    isOpenOverride = param.isOpenOverride,
    startDateRef = param.startDateRef,
    onDismiss = param.onDismiss,
    mediumDateFormatProp = param.mediumDateFormatProp;
  var buttonText = data.buttonText,
    daysBookableInAdvance = data.daysBookableInAdvance,
    midnightBookingOffset = data.midnightBookingOffset,
    validations = data.validations,
    fieldProps = _object_without_properties(data, ["buttonText", "daysBookableInAdvance", "midnightBookingOffset", "validations"]);
  var referrer = useReferrerContext().referrer;
  var _React7_useState = _sliced_to_array(React7.useState(false), 2),
    showDatePicker = _React7_useState[0],
    setShowDatePicker = _React7_useState[1];
  var _React7_useState1 = _sliced_to_array(React7.useState(fieldProps.startInvalid), 2),
    startDateError = _React7_useState1[0],
    setStartDateError = _React7_useState1[1];
  var _React7_useState2 = _sliced_to_array(React7.useState(fieldProps.endInvalid), 2),
    endDateError = _React7_useState2[0],
    setEndDateError = _React7_useState2[1];
  var dispatch = useFormAction();
  var inputs = useFormInputs();
  var addExecutor = useFormValidation().addExecutor;
  var _useLocalization = useLocalization(),
    formatDateString = _useLocalization.formatDateString,
    getWeekData = _useLocalization.getWeekData;
  var _useLogger = useLogger(),
    logWarning = _useLogger.warning;
  var track = useClickTracker();
  var startDate = React7.useMemo(function () {
    var _inputs_dateRange;
    return parseDateInput(inputs === null || inputs === void 0 ? void 0 : (_inputs_dateRange = inputs.dateRange) === null || _inputs_dateRange === void 0 ? void 0 : _inputs_dateRange.checkInDate);
  }, [inputs]);
  var endDate = React7.useMemo(function () {
    var _inputs_dateRange;
    return parseDateInput(inputs === null || inputs === void 0 ? void 0 : (_inputs_dateRange = inputs.dateRange) === null || _inputs_dateRange === void 0 ? void 0 : _inputs_dateRange.checkOutDate);
  }, [inputs]);
  var analytics = React7.useMemo(function () {
    return getAnalytics(referrer.pagePrefix, track, Boolean(startDate || endDate));
  }, [track, startDate, endDate, referrer]);
  var _useDialogWrappers = _sliced_to_array(useDialogWrappers(), 3),
    dialogWrapper = _useDialogWrappers[0],
    openDialog = _useDialogWrappers[1],
    closeDialog = _useDialogWrappers[2];
  var _useExperiment = useExperiment("AvailCal_High_and_Low_Web"),
    availCalHighAndLowWebExposure = _useExperiment.exposure,
    logAvailCalHighAndLowWebExperiment = _useExperiment.logExperiment;
  var validate = React7.useMemo(function () {
    return function (event, start, end) {
      var errors = executeValidations(event, validations, {
        startDate: start,
        endDate: end
      });
      if (errors.length) {
        dispatch({
          type: "error",
          field: fieldName,
          errors: errors
        });
        if (event !== "ON_LOAD" /* ON_LOAD */) {
          var _errors_;
          if (((_errors_ = errors[0]) === null || _errors_ === void 0 ? void 0 : _errors_.dateType) === "start") {
            focus(startDateRef);
          } else {
            focus(endDateRef);
          }
        }
        errors.forEach(function (error) {
          if (error.dateType === "end") {
            setEndDateError(error.message);
          } else {
            setStartDateError(error.message);
          }
        });
        return false;
      }
      return true;
    };
  }, [validations, dispatch, fieldName, startDateRef, endDateRef]);
  var _useFetchRatesAction = _sliced_to_array(useFetchRatesAction(isValidDate(startDate) && isValidDate(endDate)), 3),
    rates = _useFetchRatesAction[0],
    disclaimer = _useFetchRatesAction[1],
    fetchRates = _useFetchRatesAction[2];
  var firstDayOfWeek = parseInt(DayName[getWeekData().firstDay.toUpperCase()], 10);
  React7.useEffect(function () {
    var executor = function (formData, event) {
      var start = new Date(formData.get(data.startName));
      var end = new Date(formData.get(data.endName));
      return validate(event, start, end);
    };
    addExecutor(executor);
    if (startDate && endDate) {
      validate("ON_LOAD" /* ON_LOAD */, startDate, endDate);
    }
    if (autoOpenCalendar) {
      setShowDatePicker(true);
    }
  }, []);
  React7.useEffect(function () {
    setShowDatePicker(!!autoOpenCalendar);
  }, [autoOpenCalendar]);
  var onOpenCB = function (dateType, isMobile) {
    if (startDate) {
      fetchRates === null || fetchRates === void 0 ? void 0 : fetchRates(startDate);
    }
    if (isMobile) {
      openDialog(dateType);
    }
    logAvailCalHighAndLowWebExperiment(availCalHighAndLowWebExposure);
    if (rates && Object.keys(rates).length > 0) {
      track("".concat(referrer.pagePrefix, ".Property_Calendar.Rates"), "Calendar Rates visible to user");
    }
    setShowDatePicker(true);
  };
  var onDismissCB = function (isMobile) {
    if (isMobile && onDismiss) {
      onDismiss();
      return;
    }
    if (isMobile) {
      closeDialog();
      return;
    }
    setShowDatePicker(false);
  };
  var onSubmitCB = function (start, end, isMobile) {
    if (isMobile) {
      closeOnSubmit && closeDialog();
    } else {
      setShowDatePicker(false);
    }
    if ((start === null || start === void 0 ? void 0 : start.toDateString()) === (startDate === null || startDate === void 0 ? void 0 : startDate.toDateString()) && (end === null || end === void 0 ? void 0 : end.toDateString()) === (endDate === null || endDate === void 0 ? void 0 : endDate.toDateString())) {
      return;
    }
    setStartDateError("");
    setEndDateError("");
    if (!validate("ON_CHANGE" /* ON_CHANGE */, start, end)) {
      if (isMobile && closeOnSubmit) {
        closeDialog();
      }
      return;
    }
    dispatch({
      type: "change",
      field: fieldName,
      value: {
        dates: start && end ? {
          checkInDate: parseDate(start),
          checkOutDate: parseDate(end)
        } : void 0
      }
    });
  };
  var dateFieldProps = _object_spread_props(_object_spread({}, fieldProps), {
    endInvalid: endDateError,
    startInvalid: startDateError,
    routerLinkWrapper: routerLinkWrapper,
    showDatePicker: isOpenOverride !== void 0 ? isOpenOverride : showDatePicker,
    startAnalytics: analytics.startAnalytics,
    endAnalytics: analytics.endAnalytics,
    mediumDateFormatProp: mediumDateFormatProp
  });
  var datePickerProps = {
    analytics: analytics.datePickerAnalytics,
    dateFieldProps: dateFieldProps,
    datePickerContent: rates,
    footerText: disclaimer,
    dialogWrapper: dialogWrapper,
    onOpenCB: onOpenCB,
    onSubmitCB: onSubmitCB,
    onDismissCB: onDismissCB,
    buttonText: buttonText,
    startDate: startDate && isValidDate(startDate) ? formatDateString(startDate, {
      raw: "yyyy-MM-dd"
    }) : "",
    endDate: endDate && isValidDate(endDate) ? formatDateString(endDate, {
      raw: "yyyy-MM-dd"
    }) : "",
    doubleMonths: true,
    daysBookableInAdvance: daysBookableInAdvance || void 0,
    firstDayOfWeek: firstDayOfWeek,
    midnightBookingOffset: midnightBookingOffset || void 0,
    validStartDate: formatDateString(TODAY, {
      raw: "yyyy-MM-dd"
    }),
    startDateRef: startDateRef,
    endDateRef: endDateRef
  };
  if (startDateError || endDateError) {
    logWarning("SEARCH_FORM_DATE_RANGE_ERROR", "".concat(startDateError, " | ").concat(endDateError), "startDate=".concat(startDate, " endDate=").concat(endDate));
  }
  return /* @__PURE__ */React7.createElement(EGDSDatePicker, _object_spread({}, datePickerProps));
};
DateField.displayName = "DateField";
DateField.fragment = fragment;
DateField.fragment.__typename = "LodgingFormDateField";
// src/components/form/fields/isomorphic-field.tsx
import React9 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
// src/components/form/fields/submit-button/submit-button.tsx
import React8, { useContext as useContext2 } from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSButtonSize, EGDSPrimaryButton } from "@egds/react-core/button";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { adaptToAdaptExSuccessEventSchema } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext } from "@shared-ui/lodging-property-details";
import { ProductGalleryContext } from "@shared-ui/retail-product-gallery";
var fragment2 = gql8(_templateObject7());
var SubmitButton = function (param) {
  var data = param.data,
    className = param.className,
    inputRef = param.inputRef;
  var label = data.label;
  var _useContext2 = _sliced_to_array(useContext2(PropertyDetailsAdaptExContext), 1),
    adaptExState = _useContext2[0];
  var amenitiesAdaptExSuccessEvents = adaptExState.amenitiesAdaptExSuccessEvents,
    nearByPoisAdaptExSuccessEvents = adaptExState.nearByPoisAdaptExSuccessEvents;
  var referrer = useReferrerContext().referrer;
  var _useExperiment2 = useExperiment2("Adaptex_campaign_PDP_mosaic_for_large_screens"),
    imageMosaicLargeScreensExposure = _useExperiment2.exposure;
  var _useExperiment21 = useExperiment2("Adaptex_campaign_PDP_mosaic_for_small_screens"),
    imageMosaicMWebExposure = _useExperiment21.exposure;
  var adaptexCampaignVariant = imageMosaicLargeScreensExposure.bucket === 1 || imageMosaicMWebExposure.bucket === 1;
  var setAdaptExSuccessEvent = useContext2(ProductGalleryContext).setAdaptExSuccessEvent;
  var track = useClickTracker2();
  var _useClickstreamAnalytics = useClickstreamAnalytics(),
    clickStreamTrack = _useClickstreamAnalytics.track;
  var handleClick = function () {
    track("".concat(referrer.pagePrefix, ":Datepicker-Check-Availability"), "Check Availability");
    _to_consumable_array(amenitiesAdaptExSuccessEvents).concat(_to_consumable_array(nearByPoisAdaptExSuccessEvents)).forEach(function (adaptExEvent) {
      clickStreamTrack(ITrackType.EVENT, {
        data: adaptToAdaptExSuccessEventSchema(_object_spread({}, adaptExEvent))
      });
    });
    if (adaptexCampaignVariant) {
      setAdaptExSuccessEvent("ADAPTEX_MOSAIC_VIEW_CHECK_AVAILABILITY_FORM_EVENT");
    }
  };
  return /* @__PURE__ */React8.createElement(EGDSPrimaryButton, {
    onClick: handleClick,
    className: className,
    type: "submit",
    domRef: inputRef,
    isFullWidth: true,
    size: EGDSButtonSize.LARGE
  }, label);
};
SubmitButton.fragment = fragment2;
SubmitButton.fragment.__typename = "LodgingFormSubmitButton";
SubmitButton.displayName = "SubmitButton";
// src/components/form/fields/isomorphic-field.tsx
var __Query2 = gql9(_templateObject8(), DateField.fragment, SubmitButton.fragment);
function withFieldQuery(WrappedFieldFragment) {
  var FieldQuery = function (props) {
    var _data_propertyInfo_searchForm;
    var skipSsr = props.skipSsr;
    var inputs = useFormInputs();
    var _useQuery = useQuery(__Query2, {
        variables: inputs || {},
        ssr: !skipSsr
      }),
      data = _useQuery.data,
      error = _useQuery.error,
      loading = _useQuery.loading;
    if (error || loading) {
      return null;
    }
    var fieldData = data === null || data === void 0 ? void 0 : (_data_propertyInfo_searchForm = data.propertyInfo.searchForm) === null || _data_propertyInfo_searchForm === void 0 ? void 0 : _data_propertyInfo_searchForm.fields.find(function (field) {
      return field.__typename === WrappedFieldFragment.fragment.__typename;
    });
    if (!fieldData) {
      return null;
    }
    return /* @__PURE__ */React9.createElement(WrappedFieldFragment, _object_spread({
      data: fieldData
    }, props));
  };
  FieldQuery.displayName = "".concat(WrappedFieldFragment.displayName, "Query");
  return FieldQuery;
}
function isomorphicField(WrappedFieldFragment) {
  var WrappedFieldQuery = withFieldQuery(WrappedFieldFragment);
  var FieldComponent = React9.memo(function (props) {
    var data = props.data;
    if (data !== void 0) {
      return /* @__PURE__ */React9.createElement(WrappedFieldFragment, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    }
    return /* @__PURE__ */React9.createElement(WrappedFieldQuery, _object_spread({}, props));
  });
  FieldComponent.displayName = "".concat(WrappedFieldFragment.displayName, "Isomorphic");
  return FieldComponent;
}
// src/components/form/fields/travelers-field/travelers-field.tsx
import React17 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSFakeInput, EGDSTextInput } from "@egds/react-core/input";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
// src/components/form/fields/travelers-field/__private/room/room-picker.tsx
import React15 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSFloatingFullWidthButton, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSheet } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { Level as Level2, liveAnnounce as liveAnnounce3 } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
// src/components/form/fields/travelers-field/__private/localization-util.ts
function formatLocalizedString(localizedString) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var replacer = function (match) {
    var index = parseInt(match.slice(1, -1), 10);
    return args[index];
  };
  return localizedString.replace(/({\d})/g, replacer);
}
// src/components/form/fields/travelers-field/__private/traveler-action-context.tsx
import React10 from "react";
var TravelerContext = React10.createContext(function () {
  return void 0;
});
var useTravelerAction = function () {
  return React10.useContext(TravelerContext);
};
var TravelerActionProvider = TravelerContext.Provider;
// src/components/form/fields/travelers-field/__private/travelers-summary.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
var __TravelersSummaryFragment = gql10(_templateObject9());
var useTravelersDisplaySummary = function (travelersInput, data) {
  var mounted = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var rooms = travelersInput.rooms;
  var adultCount = React11.useMemo(function () {
    return rooms && rooms.length > 0 ? rooms.reduce(function (count, room) {
      return count + (room.adults || 0);
    }, 0) : 0;
  }, [rooms]);
  var childrenCount = React11.useMemo(function () {
    return rooms && rooms.length > 0 ? rooms.reduce(function (count, room) {
      var _room_children;
      return count + (((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.length) || 0);
    }, 0) : 0;
  }, [rooms]);
  var guestCount = adultCount + childrenCount;
  var formatText = useLocalization2().formatText;
  if (!mounted) {
    return guestCount.toString();
  }
  var numberOfRooms = rooms.length;
  var roomsAndGuests = data.roomsAndGuests;
  return formatText(roomsAndGuests, numberOfRooms, guestCount);
};
// src/components/form/fields/travelers-field/__private/room/room.tsx
import React14 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
// utils/text-format.ts
var interpolateText = function (icuMessage) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var populatedIcuMessage = icuMessage;
  args.forEach(function (replaceWithText, index) {
    var placeholderRegex = new RegExp("\\{".concat(index, "\\}"), "g");
    populatedIcuMessage = populatedIcuMessage.replace(placeholderRegex, replaceWithText.toString());
  });
  return populatedIcuMessage;
};
// src/components/form/fields/travelers-field/__private/room/children-ages.tsx
import React12 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var __ChildrenAgesFragment = gql11(_templateObject10());
var MIN_CHILD_AGE = 0;
var MAX_CHILD_AGE = 17;
var getChildrenAgeSelectOptions = function (youngestChildAgeText) {
  var options = [];
  for (var i = MIN_CHILD_AGE; i <= MAX_CHILD_AGE; i += 1) {
    var name = i === 0 ? formatLocalizedString(youngestChildAgeText, MIN_CHILD_AGE + 1) : i.toString();
    options.push({
      value: "".concat(i),
      name: name
    });
  }
  return options;
};
var ChildrenAges = function (param) {
  var childAge = param.childAge,
    childIndex = param.childIndex,
    roomIndex = param.roomIndex,
    data = param.data;
  var childAgeUpdatedLiveAnnounce = data.childAgeUpdatedLiveAnnounce,
    selectChildAgeLabel = data.selectChildAgeLabel,
    youngestChildAgeText = data.youngestChildAgeText;
  var dispatch = useTravelerAction();
  var track = useClickTracker3();
  var referrer = useReferrerContext().referrer;
  var ageOptions = React12.useMemo(function () {
    return getChildrenAgeSelectOptions(youngestChildAgeText);
  }, [youngestChildAgeText]);
  var onChange = function (event) {
    var age = parseInt(event.target.value, 10);
    if (!Number.isNaN(age)) {
      dispatch({
        type: "UPDATE_CHILD_AGE",
        roomIndex: roomIndex,
        childIndex: childIndex,
        childAge: age
      });
    }
    track("".concat(referrer.pagePrefix, ":ROOM.").concat(roomIndex, ".Child.").concat(childIndex, ".AGE.").concat(age), "Child age update");
    liveAnnounce(formatLocalizedString(childAgeUpdatedLiveAnnounce, childIndex, age), Level.POLITE);
  };
  var elementName = "child-".concat(roomIndex, "-").concat(childIndex);
  var elementId = "age-".concat(childIndex);
  return /* @__PURE__ */React12.createElement(EGDSSelect, {
    label: formatLocalizedString(selectChildAgeLabel, childIndex + 1),
    id: elementId,
    name: elementName,
    value: childAge.toString(),
    onChange: onChange
  }, ageOptions.map(function (option) {
    return /* @__PURE__ */React12.createElement("option", {
      key: option.value,
      value: option.value
    }, option.name);
  }));
};
ChildrenAges.displayName = "ChildrenAges";
ChildrenAges.fragment = __ChildrenAgesFragment;
// src/components/form/fields/travelers-field/__private/room/travelers-step-input.tsx
import React13 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSStepInput } from "@egds/react-core/step-input";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var __TravelersStepInputFragment = gql12(_templateObject11());
var TravelersStepInput = function (param) {
  var data = param.data,
    min = param.min,
    max = param.max,
    roomIndex = param.roomIndex,
    roomCount = param.roomCount,
    room = param.room,
    travelerType = param.travelerType;
  var _room_children;
  var title = data.title,
    increaseText = data.increaseText,
    decreaseText = data.decreaseText,
    caption = data.caption;
  var referrer = useReferrerContext().referrer;
  var track = useClickTracker4();
  var dispatch = useTravelerAction();
  var actionType = travelerType === "adults" /* ADULTS */ ? "UPDATE_ADULTS_COUNT" : "UPDATE_CHILDREN_COUNT";
  var onChange = function (event) {
    var count = parseInt(event.target.value, 10);
    if (!Number.isNaN(count)) {
      dispatch({
        type: actionType,
        roomIndex: roomIndex,
        count: count
      });
    }
  };
  var guestCountAnalytics = React13.useMemo(function () {
    return {
      id: "".concat(referrer.pagePrefix, ":Guest"),
      description: "Adjust guest count in change search",
      callback: function (id, desc) {
        return track(id, desc);
      }
    };
  }, [track]);
  var travelerId = "room-".concat(roomCount, "-").concat(roomIndex, "-").concat(travelerType);
  var inputValue = travelerType === "adults" /* ADULTS */ ? room.adults : (_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.length;
  return /* @__PURE__ */React13.createElement(EGDSStepInput, {
    label: title,
    incrementText: formatLocalizedString(increaseText, roomIndex + 1),
    incrementId: "".concat(travelerId, "-increase"),
    decrementText: formatLocalizedString(decreaseText, roomIndex + 1),
    decrementId: "".concat(travelerId, "-decrease"),
    description: caption || void 0,
    min: min,
    max: max,
    value: inputValue,
    onChange: onChange,
    analytics: guestCountAnalytics,
    id: travelerId
  });
};
TravelersStepInput.displayName = "TravelersStepInput";
TravelersStepInput.fragment = __TravelersStepInputFragment;
// src/components/form/fields/travelers-field/__private/room/room.tsx
var __RoomFragment = gql13(_templateObject12(), __TravelersStepInputFragment, __ChildrenAgesFragment);
var MAX_CHILDREN_PER_ROOM = 6;
var MAX_TRAVELERS = 14;
var Room = function (param) {
  var headerRef = param.headerRef,
    roomInput = param.room,
    roomCount = param.roomCount,
    roomIndex = param.roomIndex,
    singleUnit = param.singleUnit,
    totalTravelers = param.totalTravelers,
    data = param.data;
  var _roomInput_children, _roomInput_children1, _roomInput_children2;
  var isLastRoom = roomCount === roomIndex + 1;
  var roomTitleAriaLabel = data.roomTitleAriaLabel,
    roomTitle = data.roomTitle,
    removeRoomButtonLabel = data.removeRoomButtonLabel,
    removeRoomButtonAriaLabel = data.removeRoomButtonAriaLabel,
    adultsStepInput = data.adultsStepInput,
    childrenStepInput = data.childrenStepInput,
    childrenAges = data.childrenAges,
    roomRemovedLiveAnnounce = data.roomRemovedLiveAnnounce;
  var track = useClickTracker5();
  var dispatch = useTravelerAction();
  var referrer = useReferrerContext().referrer;
  var onRemoveRoom = function () {
    dispatch({
      type: "REMOVE_ROOM",
      roomIndex: roomIndex
    });
    track("".concat(referrer.pagePrefix, ":RemoveRoom"), "Remove room");
    liveAnnounce2(formatLocalizedString(roomRemovedLiveAnnounce, roomCount));
  };
  return /* @__PURE__ */React14.createElement(EGDSSpacing, {
    key: "room-".concat(roomCount, "-").concat(roomIndex),
    padding: !singleUnit ? {
      block: "three"
    } : {
      blockend: "three"
    },
    margin: !singleUnit ? {
      block: "three"
    } : {
      blockend: "three"
    },
    border: !singleUnit ? ["blockend"] : void 0
  }, /* @__PURE__ */React14.createElement("div", null, /* @__PURE__ */React14.createElement("h3", {
    tabIndex: -1,
    className: "uitk-type-200 uitk-type-medium",
    "aria-label": formatLocalizedString(roomTitleAriaLabel, roomIndex + 1, roomCount),
    ref: isLastRoom ? headerRef : null
  }, /* @__PURE__ */React14.createElement("span", {
    "aria-hidden": "true"
  }, formatLocalizedString(roomTitle, roomIndex + 1))), /* @__PURE__ */React14.createElement(TravelersStepInput, {
    travelerType: "adults" /* ADULTS */,
    min: 1,
    max: roomInput.adults + MAX_TRAVELERS - totalTravelers,
    roomIndex: roomIndex,
    roomCount: roomCount,
    room: roomInput,
    data: adultsStepInput
  }), /* @__PURE__ */React14.createElement(TravelersStepInput, {
    travelerType: "children" /* CHILDREN */,
    min: 0,
    max: Math.min(MAX_CHILDREN_PER_ROOM, (((_roomInput_children = roomInput.children) === null || _roomInput_children === void 0 ? void 0 : _roomInput_children.length) || 0) + MAX_TRAVELERS - totalTravelers),
    roomIndex: roomIndex,
    roomCount: roomCount,
    room: roomInput,
    data: childrenStepInput
  }), roomInput.children && ((_roomInput_children1 = roomInput.children) === null || _roomInput_children1 === void 0 ? void 0 : _roomInput_children1.length) > 0 && /* @__PURE__ */React14.createElement(EGDSLayoutGrid, {
    space: "two",
    columns: 2
  }, (_roomInput_children2 = roomInput.children) === null || _roomInput_children2 === void 0 ? void 0 : _roomInput_children2.map(function (param, childIndex) {
    var age = param.age;
    return /* @__PURE__ */React14.createElement(ChildrenAges, {
      key: childIndex,
      childAge: age,
      childIndex: childIndex,
      roomIndex: roomIndex,
      data: childrenAges
    });
  })), roomIndex !== 0 && /* @__PURE__ */React14.createElement(EGDSSpacing, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React14.createElement(EGDSLayoutFlex, {
    justifyContent: "end"
  }, /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React14.createElement(EGDSTertiaryButton, {
    onClick: onRemoveRoom,
    "aria-label": interpolateText(removeRoomButtonAriaLabel, roomIndex + 1, roomCount)
  }, removeRoomButtonLabel))))));
};
Room.displayName = "Room";
Room.fragment = __RoomFragment;
// src/components/form/fields/travelers-field/__private/room/room-picker.tsx
var __RoomPickerFragment = gql14(_templateObject13(), __RoomFragment, __TravelersSummaryFragment);
var DEFAULT_SA_CHILD_AGE = 0;
var MAX_ROOM_COUNT = 8;
var MAX_TRAVELERS2 = 14;
var roomPickerReducer = function (state, action) {
  switch (action.type) {
    case "ADD_ROOM":
      {
        return _object_spread_props(_object_spread({}, state), {
          rooms: state.rooms.concat([{
            adults: 1
          }])
        });
      }
    case "REMOVE_ROOM":
      {
        var roomIndex = action.roomIndex;
        return _object_spread_props(_object_spread({}, state), {
          rooms: state.rooms.filter(function (_, index) {
            return index !== roomIndex;
          })
        });
      }
    case "UPDATE_ADULTS_COUNT":
      {
        var roomIndex1 = action.roomIndex,
          count = action.count;
        return _object_spread_props(_object_spread({}, state), {
          rooms: state.rooms.map(function (room, index) {
            return index === roomIndex1 ? _object_spread_props(_object_spread({}, room), {
              adults: count
            }) : room;
          })
        });
      }
    case "UPDATE_CHILDREN_COUNT":
      {
        var _state_rooms_roomIndex_children, _state_rooms_roomIndex;
        var roomIndex2 = action.roomIndex,
          count1 = action.count;
        var _state_rooms_roomIndex_children_length;
        var childrenAdded = count1 > ((_state_rooms_roomIndex_children_length = (_state_rooms_roomIndex = state.rooms[roomIndex2]) === null || _state_rooms_roomIndex === void 0 ? void 0 : (_state_rooms_roomIndex_children = _state_rooms_roomIndex.children) === null || _state_rooms_roomIndex_children === void 0 ? void 0 : _state_rooms_roomIndex_children.length) !== null && _state_rooms_roomIndex_children_length !== void 0 ? _state_rooms_roomIndex_children_length : 0);
        return _object_spread_props(_object_spread({}, state), {
          rooms: state.rooms.map(function (room, index) {
            if (index === roomIndex2) {
              var _room_children, _room_children1;
              return _object_spread_props(_object_spread({}, room), {
                children: childrenAdded ? ((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.concat([{
                  age: DEFAULT_SA_CHILD_AGE
                }])) || [{
                  age: DEFAULT_SA_CHILD_AGE
                }] : (_room_children1 = room.children) === null || _room_children1 === void 0 ? void 0 : _room_children1.slice(0, -1)
              });
            }
            return room;
          })
        });
      }
    case "UPDATE_CHILD_AGE":
      {
        var roomIndex3 = action.roomIndex,
          childIndex = action.childIndex,
          childAge = action.childAge;
        return _object_spread_props(_object_spread({}, state), {
          rooms: state.rooms.map(function (room, index) {
            if (roomIndex3 === index) {
              var _room_children;
              return _object_spread_props(_object_spread({}, room), {
                children: (_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.map(function (child, j) {
                  return childIndex === j ? {
                    age: childAge
                  } : child;
                })
              });
            }
            return room;
          })
        });
      }
    default:
      return state;
  }
};
var RoomPicker = function (param) {
  var data = param.data,
    onDismiss = param.onDismiss,
    onSave = param.onSave,
    onUpdate = param.onUpdate,
    _param_submitDisabled = param.submitDisabled,
    submitDisabled = _param_submitDisabled === void 0 ? false : _param_submitDisabled,
    travelersInput = param.travelersInput,
    triggerRef = param.triggerRef;
  var reducer = function (state2, action) {
    var newState = roomPickerReducer(state2, action);
    if (onUpdate) {
      onUpdate(newState);
    }
    return newState;
  };
  var _React15_useReducer = _sliced_to_array(React15.useReducer(reducer, travelersInput), 2),
    state = _React15_useReducer[0],
    dispatch = _React15_useReducer[1];
  var roomPicker = data.roomPicker;
  var accessibility = roomPicker.accessibility,
    toolBarIconLabel = roomPicker.toolBarIconLabel,
    toolBarTitle = roomPicker.toolBarTitle,
    addRoomText = roomPicker.addRoomText,
    doneLabel = roomPicker.doneLabel,
    roomData = roomPicker.room,
    roomAddedLiveAnnounce = roomPicker.roomAddedLiveAnnounce;
  var lastRoomHeaderRef = React15.useRef(null);
  var referrer = useReferrerContext().referrer;
  var track = useClickTracker6();
  var setFocusOnLastRoomHeader = function () {
    var _lastRoomHeaderRef_current;
    if (typeof (lastRoomHeaderRef === null || lastRoomHeaderRef === void 0 ? void 0 : (_lastRoomHeaderRef_current = lastRoomHeaderRef.current) === null || _lastRoomHeaderRef_current === void 0 ? void 0 : _lastRoomHeaderRef_current.focus) === "function") {
      lastRoomHeaderRef.current.focus();
    }
  };
  React15.useEffect(function () {
    setFocusOnLastRoomHeader();
  }, [state.rooms.length]);
  var resetLiveAnnounce = function () {
    liveAnnounce3("", Level2.ASSERTIVE);
  };
  var roomPickerToolbarAnalytics = React15.useMemo(function () {
    return {
      id: "".concat(referrer.pagePrefix, ":ChangeRoomGuest"),
      description: "Close Room Picker",
      callback: function (id, desc) {
        return track(id, desc);
      }
    };
  }, [track]);
  var handleDismiss = function () {
    if (onDismiss) {
      resetLiveAnnounce();
      onDismiss();
    }
  };
  var onAddRoom = function () {
    dispatch({
      type: "ADD_ROOM"
    });
    track("".concat(referrer.pagePrefix, ":AddRoom"), "Add room");
    liveAnnounce3(formatLocalizedString(roomAddedLiveAnnounce, state.rooms.length), Level2.POLITE);
  };
  var numTravelers = state.rooms.reduce(function (prev, room) {
    var _room_children;
    return prev + room.adults + (((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.length) || 0);
  }, 0);
  var disableAddRoom = state.rooms.length >= MAX_ROOM_COUNT || numTravelers >= MAX_TRAVELERS2;
  var handleSubmit = function () {
    if (onSave) {
      resetLiveAnnounce();
      onSave(state);
    }
  };
  return /* @__PURE__ */React15.createElement(TravelerActionProvider, {
    value: dispatch
  }, /* @__PURE__ */React15.createElement(EGDSSheet, {
    ariaModal: false,
    type: "centered",
    centeredSheetSize: "small",
    isVisible: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React15.createElement(EGDSToolbar, {
    toolbarTitleA11yText: accessibility,
    toolbarTitle: toolBarTitle,
    navigationContent: {
      onClick: handleDismiss,
      onClickAnalytics: roomPickerToolbarAnalytics,
      navType: "close",
      navIconLabel: toolBarIconLabel
    }
  }), /* @__PURE__ */React15.createElement(EGDSSpacing2, {
    className: "uitk-scroll-vertical",
    padding: {
      inline: "four",
      blockstart: "half",
      blockend: "three"
    }
  }, /* @__PURE__ */React15.createElement("section", null, state.rooms.map(function (room, roomIndex) {
    return /* @__PURE__ */React15.createElement(Room, {
      data: roomData,
      headerRef: lastRoomHeaderRef,
      key: roomIndex,
      room: room,
      roomCount: state.rooms.length,
      roomIndex: roomIndex,
      singleUnit: !addRoomText,
      totalTravelers: numTravelers
    });
  }), addRoomText && /* @__PURE__ */React15.createElement(EGDSSpacing2, {
    padding: {
      blockstart: "four",
      blockend: "twelve"
    }
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex2, {
    justifyContent: "end"
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React15.createElement(EGDSTertiaryButton2, {
    onClick: onAddRoom,
    disabled: disableAddRoom
  }, addRoomText)))), /* @__PURE__ */React15.createElement(EGDSFloatingFullWidthButton, {
    size: EGDSButtonSize2.LARGE,
    onClick: handleSubmit,
    disabled: submitDisabled
  }, doneLabel)))));
};
RoomPicker.displayName = "RoomPicker";
RoomPicker.fragment = __RoomPickerFragment;
// src/components/form/fields/travelers-field/__private/travelers-hidden-inputs.tsx
import React16 from "react";
var useHiddenTravelerInputs = function (rooms) {
  var adultsString = React16.useMemo(function () {
    return rooms.map(function (room) {
      return room.adults;
    }).filter(function (adult) {
      return adult > 0;
    }).join(",");
  }, [rooms]);
  var childrenString = React16.useMemo(function () {
    return rooms.map(function (room, index) {
      var _room_children;
      return (_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.map(function (child) {
        return "".concat(index + 1, "_").concat(child.age);
      }).join(",");
    }).filter(function (child) {
      return child && child !== "";
    }).join(",");
  }, [rooms]);
  return {
    adultsString: adultsString,
    childrenString: childrenString
  };
};
var TravelersHiddenInput = function (param) {
  var rooms = param.rooms;
  var _useHiddenTravelerInputs = useHiddenTravelerInputs(rooms),
    adultsString = _useHiddenTravelerInputs.adultsString,
    childrenString = _useHiddenTravelerInputs.childrenString;
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, adultsString && /* @__PURE__ */React16.createElement("input", {
    type: "hidden",
    name: "adults",
    value: adultsString,
    readOnly: true
  }), childrenString && /* @__PURE__ */React16.createElement("input", {
    type: "hidden",
    name: "children",
    value: childrenString,
    readOnly: true
  }));
};
TravelersHiddenInput.displayName = "TravelersHiddenInput";
// src/components/form/fields/travelers-field/types.ts
var TravelersFieldTriggerType = /* @__PURE__ */function (TravelersFieldTriggerType2) {
  TravelersFieldTriggerType2["INPUT"] = "input";
  TravelersFieldTriggerType2["LINK"] = "link";
  return TravelersFieldTriggerType2;
}(TravelersFieldTriggerType || {});
// src/components/form/fields/travelers-field/travelers-field.tsx
var fragment3 = gql15(_templateObject14(), __RoomPickerFragment, __TravelersSummaryFragment);
var DEFAULT_ROOM_INPUT = [{
  adults: 2
}];
var TravelersField = function (param) {
  var fieldName = param.fieldName,
    className = param.className,
    data = param.data,
    _param_closeOnSubmit = param.closeOnSubmit,
    closeOnSubmit = _param_closeOnSubmit === void 0 ? true : _param_closeOnSubmit,
    trigger = param.trigger;
  var _React17_useState = _sliced_to_array(React17.useState(false), 2),
    mounted = _React17_useState[0],
    setMounted = _React17_useState[1];
  var travelersFieldRef = React17.useRef(null);
  var referrer = useReferrerContext().referrer;
  var dispatch = useFormAction();
  var inputs = useFormInputs();
  var _useDialog2 = _sliced_to_array(useDialog2("travelerPicks"), 3),
    isDialogOpen = _useDialog2[0],
    _useDialog2_ = _useDialog2[1],
    closeDialog = _useDialog2_.closeDialog,
    openDialog = _useDialog2_.openDialog,
    DialogComponent = _useDialog2[2];
  var track = useClickTracker7();
  var triggerRef = React17.useRef(null);
  var roomInput = (inputs === null || inputs === void 0 ? void 0 : inputs.roomInput) || DEFAULT_ROOM_INPUT;
  var _React17_useState1 = _sliced_to_array(React17.useState(roomInput), 2),
    localRoomInput = _React17_useState1[0],
    setLocalRoomInput = _React17_useState1[1];
  React17.useEffect(function () {
    if (roomInput) {
      setLocalRoomInput(roomInput);
    }
  }, [roomInput]);
  var label = data.label,
    travelersSummary = data.travelersSummary;
  var localTravelersInput = {
    rooms: localRoomInput
  };
  var travelersDisplaySummaryWithPets = useTravelersDisplaySummary(localTravelersInput, travelersSummary, mounted);
  var travelersDisplaySummaryWithoutPets = useTravelersDisplaySummary({
    rooms: localRoomInput
  }, travelersSummary, mounted);
  React17.useEffect(function () {
    setMounted(true);
  }, []);
  var setFocusOnTravelersField = function () {
    var _travelersFieldRef_current;
    if (typeof (travelersFieldRef === null || travelersFieldRef === void 0 ? void 0 : (_travelersFieldRef_current = travelersFieldRef.current) === null || _travelersFieldRef_current === void 0 ? void 0 : _travelersFieldRef_current.focus) === "function") {
      travelersFieldRef.current.focus();
    }
  };
  var onDismiss = function () {
    closeDialog();
    setFocusOnTravelersField();
  };
  var onSave = function (travelersInput) {
    var rooms = travelersInput.rooms;
    setLocalRoomInput(rooms);
    dispatch({
      type: "change",
      field: fieldName,
      value: travelersInput
    });
    track("".concat(referrer.pagePrefix, ":ChangeRoomGuestDone"), "Apply Room Picker");
    setFocusOnTravelersField();
    if (closeOnSubmit) {
      closeDialog();
    }
  };
  var onOpen = function () {
    openDialog();
    track("".concat(referrer.pagePrefix, ":ChangeRoomGuest"), "Open Room Picker");
  };
  if (trigger === "link" /* LINK */) {
    return /* @__PURE__ */React17.createElement(React17.Fragment, null, /* @__PURE__ */React17.createElement(EGDSLink, {
      onClick: onOpen,
      inline: true
    }, /* @__PURE__ */React17.createElement("button", {
      type: "button",
      ref: triggerRef
    }, /* @__PURE__ */React17.createElement(EGDSText, {
      size: 300
    }, travelersDisplaySummaryWithoutPets))), /* @__PURE__ */React17.createElement(TravelersHiddenInput, {
      rooms: localRoomInput
    }), /* @__PURE__ */React17.createElement(EGDSSheetTransition2, {
      isVisible: isDialogOpen
    }, /* @__PURE__ */React17.createElement(DialogComponent, null, /* @__PURE__ */React17.createElement(RoomPicker, {
      travelersInput: localTravelersInput,
      onSave: onSave,
      onDismiss: closeDialog,
      data: data,
      triggerRef: triggerRef
    }))));
  }
  var commonInputProps = {
    id: "travelers-field-id",
    label: label,
    icon: "person"
  };
  var commonTextInputProps = _object_spread_props(_object_spread({}, commonInputProps), {
    name: "adults"
  });
  var commonFakeInputProps = _object_spread_props(_object_spread({}, commonInputProps), {
    onChange: onOpen,
    onClick: onOpen,
    domRef: travelersFieldRef
  });
  var unmountedInput = /* @__PURE__ */React17.createElement(Experiment, {
    name: "Vrbex_pets_toggle"
  }, /* @__PURE__ */React17.createElement(ExperimentControl, null, /* @__PURE__ */React17.createElement(EGDSTextInput, _object_spread_props(_object_spread({}, commonTextInputProps), {
    value: travelersDisplaySummaryWithoutPets,
    domRef: triggerRef
  }))), /* @__PURE__ */React17.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React17.createElement(EGDSTextInput, _object_spread_props(_object_spread({}, commonTextInputProps), {
    value: travelersDisplaySummaryWithPets,
    domRef: triggerRef
  }))));
  var mountedInput = /* @__PURE__ */React17.createElement(Experiment, {
    name: "Vrbex_pets_toggle"
  }, /* @__PURE__ */React17.createElement(ExperimentControl, null, /* @__PURE__ */React17.createElement(EGDSFakeInput, _object_spread_props(_object_spread({}, commonFakeInputProps), {
    value: travelersDisplaySummaryWithoutPets,
    domRef: triggerRef
  }))), /* @__PURE__ */React17.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React17.createElement(EGDSFakeInput, _object_spread_props(_object_spread({}, commonFakeInputProps), {
    value: travelersDisplaySummaryWithPets,
    domRef: triggerRef
  }))));
  return /* @__PURE__ */React17.createElement("div", {
    className: className
  }, !mounted && unmountedInput, mounted && /* @__PURE__ */React17.createElement(React17.Fragment, null, mountedInput, /* @__PURE__ */React17.createElement(TravelersHiddenInput, {
    rooms: localRoomInput
  })), /* @__PURE__ */React17.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React17.createElement(DialogComponent, null, /* @__PURE__ */React17.createElement(RoomPicker, {
    travelersInput: localTravelersInput,
    onSave: onSave,
    onDismiss: onDismiss,
    data: data,
    triggerRef: triggerRef
  }))));
};
TravelersField.displayName = "TravelersField";
TravelersField.fragment = _object_spread_props(_object_spread({}, fragment3), {
  __typename: "LodgingFormTravelers"
});
// src/components/form/fields/index.ts
var DateField2 = isomorphicField(DateField);
var TravelersField2 = isomorphicField(TravelersField);
var SubmitButton2 = isomorphicField(SubmitButton);
export { DateField2 as DateField, FormActionProvider, FormInputsProvider, LodgingForm, LodgingFormEvent, ReferrerContext, RoomPicker, SubmitButton2 as SubmitButton, TravelersField2 as TravelersField, TravelersFieldTriggerType, __RoomPickerFragment, defaultReferrerContext, useFetchRatesAction, useFormAction, useReferrerContext }; /* istanbul ignore next -- @preserve */ /* istanbul ignore file -- @preserve */ // istanbul ignore next -- @preserve